import http from '@/communication/AuthConnection'

export default ({ commit }, { eventId }) => {
  http.get(`/v1/item-association/${eventId}`)
    .then((eventPayload) => {
      commit('SET_LIST_ITEMS', { listItems: eventPayload.data.eventItems })

      // Selecting item to quote
      const initialItemSelected = eventPayload.data.eventItems[0]
      commit('SET_SELECTED_ITEM', { itemDetail: initialItemSelected })

      // Set event info
      const eventDetail = eventPayload.data.eventDetails
      commit('Events/SET_EVENT_INFO', { eventDetail }, { root: true })
    })
}



// WEBPACK FOOTER //
// ./src/brain/item-association/LoadEvent.js